import { useCallback, useContext } from "react";
import Typography from "components/Typography";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import Dialog from "components/DialogV2";
import DialogHeader from "components/DialogV2/DialogHeader";
import DialogContent from "components/DialogV2/DialogContent";
import DialogClose from "components/DialogV2/DialogClose";
import DialogTitle from "components/DialogV2/DialogTitle";
import MeasurementsContext from "contexts/MeasurementsContext";
import DialogActions from "components/DialogV2/DialogActions";

interface DeleteMeasurementDialogProps {
  measurementId: string;
  open: boolean;
  onClose: () => void;
}

function DeleteMeasurementDialog(props: DeleteMeasurementDialogProps) {
  const { measurementId, onClose, open } = props;
  const { t } = useTranslation();

  const measurementsContextValue = useContext(MeasurementsContext);

  const handleDelete = useCallback(() => {
    if (!measurementsContextValue) return;
    const [, { deleteById }] = measurementsContextValue;
    deleteById(measurementId);
  }, [measurementId, measurementsContextValue]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader>
        <DialogTitle>{t("charting.delete_exercise_measurement")}</DialogTitle>
        <DialogClose />
      </DialogHeader>
      <DialogContent>
        <Typography textAlign="center" fontWeight="fontWeightMedium" mb={0.5}>
          {t("charting.delete_exercise_measurement_confirmation")}
        </Typography>
        <Typography variant="TextS" textAlign="center">
          {t("charting.delete_exercise_measurement_description")}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexDirection: "column", gap: 2 }}>
        <Button variant="danger" size="small" fullWidth onClick={handleDelete}>
          {t("global.delete_button_text")}
        </Button>
        <Button variant="tertiary" size="small" fullWidth onClick={onClose}>
          {t("global.cancel_button_text")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteMeasurementDialog;
